import { normalizeDocumentNumber } from "../NormalizeDocumentNumber";

/**
 * Formata CNPJ alfanumérico ou numérico: XX.XXX.XXX/XXXX-XX
 * Funciona com entrada parcial (formatação progressiva).
 */
export function formatCnpj(value: string): string {
  const cnpj = value?.slice(0, 14);

  if (!cnpj) return "";

  const parts = [
    cnpj.slice(0, 2),
    cnpj.slice(2, 5),
    cnpj.slice(5, 8),
    cnpj.slice(8, 12),
    cnpj.slice(12, 14)
    // Remove partes vazias para suportar entrada parcial (formatação progressiva)
  ].filter(Boolean);

  if (parts.length <= 1) return parts[0] || "";

  if (parts.length === 2) return `${parts[0]}.${parts[1]}`;

  if (parts.length === 3) return `${parts[0]}.${parts[1]}.${parts[2]}`;

  if (parts.length === 4)
    return `${parts[0]}.${parts[1]}.${parts[2]}/${parts[3]}`;

  return `${parts[0]}.${parts[1]}.${parts[2]}/${parts[3]}-${parts[4]}`;
}

export function cpfCnpjFormatter(cpfOrCnpj: string): string {
  const cleaned = normalizeDocumentNumber(cpfOrCnpj);

  if (!cleaned) return "";

  if (cleaned.length <= 11 && !/[a-zA-Z]/.test(cleaned)) {
    // CPF (sempre numérico)
    let cpf = cleaned;
    cpf = cpf.replace(/(\d{3})(\d)/, "$1.$2");
    cpf = cpf.replace(/(\d{3})(\d)/, "$1.$2");
    cpf = cpf.replace(/(\d{3})(\d{1,2})$/, "$1-$2");

    return cpf;
  }

  // CNPJ (alfanumérico)
  return formatCnpj(cleaned);
}
